import { FC, Fragment } from "react"
import { useSelector } from "react-redux"
import { Navigate, Outlet } from "react-router-dom"
import PageWrapper from "../../layout/PageWrapper/PageWrapper"
import { RootState } from "../../redux/store"
import Header from "./_headers/DefaultHeader"
import Sidebar from "./_sidebar/sidebar"

interface AppLayoutProps {
    children?: React.ReactNode
}

const AppLayout: FC<AppLayoutProps> = ({ children }) => {

    const { isAuthenticated } = useSelector((state: RootState) => state.auth);
    const { collapsed, hoverCollapsed, isDesktop } = useSelector((state: RootState) => state.sidebarSlice);

    if (isAuthenticated) {
        return (
            <Fragment>
                <Sidebar className="fixed hidden xl:block dark:bg-gray-50" />
                <div
                  className={
                    isDesktop && collapsed && !hoverCollapsed
                      ? "wrapper flex w-full flex-col xl:ms-[80px] xl:w-[calc(100%-80px)] 2xl:ms-[80px] 2xl:w-[calc(100%-80px)]"
                      : "wrapper flex w-full flex-col xl:ms-[270px] xl:w-[calc(100%-270px)] 2xl:ms-72 2xl:w-[calc(100%-288px)]"
                  }
                >
                    <Header />
                    <main className="content">
                        <PageWrapper>
                            <Outlet />
                        </PageWrapper>
                    </main>
                </div>
            </Fragment>
        )
    };

    return <Navigate to="/login" />;
}

export default AppLayout;            